import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { MdDeleteOutline } from "react-icons/md";
import styles from "./Dashboard.module.scss";
import useCloudinary from "../../utils/useCloudinary";
import { getGalleryEntry, createGalleryEntry, deleteGalleryImage } from "../../utils/network/Crud";

const ManageGallery = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteUrl, setDeleteUrl] = useState(null);
  const { uploadImage, uploading } = useCloudinary();

  const loadGallery = async () => {
    setLoading(true);
    const result = await getGalleryEntry();
    setImages(result?.data?.images || []);
    setLoading(false);
  };

  useEffect(() => {
    loadGallery();
  }, []);

  const handleUpload = async (e) => {
    const files = e.target.files;
    if (!files?.length) return;
    try {
      const urls = await uploadImage(files);
      const urlArray = Array.isArray(urls) ? urls : [urls];
      await createGalleryEntry(urlArray);
      toast.success("Photos uploaded");
      loadGallery();
    } catch (error) {
      toast.error("Upload failed");
    }
    e.target.value = "";
  };

  const handleDelete = async () => {
    try {
      await deleteGalleryImage(deleteUrl);
      toast.success("Photo removed");
      setDeleteUrl(null);
      loadGallery();
    } catch (error) {
      toast.error("Failed to remove photo");
    }
  };

  return (
    <div>
      <div className={styles.pageHeader}>
        <div>
          <h2>Gallery</h2>
          <p>Upload and manage photos shown on the public Gallery page.</p>
        </div>
        <label className={styles.primaryBtn} style={{ cursor: "pointer" }}>
          {uploading ? "Uploading…" : "Upload Photos"}
          <input
            type="file"
            accept="image/*"
            multiple
            hidden
            disabled={uploading}
            onChange={handleUpload}
          />
        </label>
      </div>

      <div className={styles.panel}>
        {loading ? (
          <div className={styles.emptyState}>Loading…</div>
        ) : images.length === 0 ? (
          <div className={styles.emptyState}>No photos uploaded yet.</div>
        ) : (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
              gap: 14,
            }}
          >
            {images.map((url, idx) => (
              <div key={idx} style={{ position: "relative" }}>
                <img
                  src={url}
                  alt={`gallery-${idx}`}
                  style={{
                    width: "100%",
                    height: 120,
                    objectFit: "cover",
                    borderRadius: 10,
                    border: "1px solid rgba(240,178,60,0.18)",
                  }}
                />
                <button
                  className={styles.iconBtn}
                  style={{
                    position: "absolute",
                    top: 4,
                    right: 4,
                    background: "rgba(10,8,18,0.7)",
                  }}
                  onClick={() => setDeleteUrl(url)}
                >
                  <MdDeleteOutline />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {deleteUrl && (
        <div className={styles.modalOverlay} onClick={() => setDeleteUrl(null)}>
          <div className={styles.modalCard} onClick={(e) => e.stopPropagation()}>
            <h3>Remove Photo?</h3>
            <p style={{ color: "#b6acc9", fontSize: 13 }}>This action cannot be undone.</p>
            <div className={styles.modalActions}>
              <button className={styles.secondaryBtn} onClick={() => setDeleteUrl(null)}>
                Cancel
              </button>
              <button className={`${styles.primaryBtn} ${styles.dangerBtn}`} onClick={handleDelete}>
                Remove
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManageGallery;
